import { render, staticRenderFns } from "./TireRecommendationQuestion.vue?vue&type=template&id=2395c038"
import script from "./TireRecommendationQuestion.vue?vue&type=script&lang=ts"
export * from "./TireRecommendationQuestion.vue?vue&type=script&lang=ts"
import style0 from "./TireRecommendationQuestion.vue?vue&type=style&index=0&id=2395c038&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports